import { configureStore } from '@reduxjs/toolkit';

import { editorReducer } from '@/features/constructor/editorSlice';
import { uiReducer } from './uiSlice';

/**
 * Redux holds only client state.
 *
 * Server data lives in the Apollo cache; duplicating it here would mean two
 * sources of truth and a lot of manual invalidation. What Redux is good at, and
 * what the constructor needs, is a deep mutable tree with undo/redo - so that is
 * all it owns.
 */
export const store = configureStore({
  reducer: {
    ui: uiReducer,
    editor: editorReducer,
  },
  middleware: (getDefault) =>
    getDefault({
      // The editor keeps template documents of a few hundred kilobytes; deep
      // scanning them on every dispatch stalls typing in the inspector.
      serializableCheck: false,
      immutableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
